<router-outlet></router-outlet>
<ngx-ui-loader text="Loading..." fgsColor="#f5365c"></ngx-ui-loader>